<div class="fuse-card auto-width mb-12 mat-card mat-elevation-z2 p-0" [ngClass.gt-sm]="'mb-0 p-0 m-b-6'">
    <div class="p-10 warning-panel" fxlayout="row" fxlayoutalign="space-between center">

        <p class="warning-text">{{employeeService.EmployeeWarningText}}</p>

        <div fxlayout="row wrap" fxlayoutalign="space-between center">

            <button mat-icon-button (click)="EditWarningText()">
                <mat-icon class="f-s-19 mat-icon material-icons mat-icon-no-color">edit</mat-icon>
            </button>
            <button mat-icon-button (click)="DeleteWarningText()">
                <mat-icon class="f-s-19 mat-icon material-icons mat-icon-no-color">delete_forever</mat-icon>
            </button>
        </div>
    </div>
</div>